











































































































import { Component, Vue } from 'vue-property-decorator';
import { SysKBContentListModule } from '@/store/modules/sysKBContentList';
import Alert from '@/components/Shared/Alert.vue';
import KBStatusBadge from '@/components/KnowledgeBase/KBStatusBadge.vue';
import KBVisibilityBadge from '@/components/KnowledgeBase/KBVisibilityBadge.vue';
import CreateKBContent from '@/components/KnowledgeBase/CreateKBContent.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';
import KBStatus from '@/models/KnowledgeBase/KBStatus';

@Component({
  name: 'SysAdminKnowledgeBase',
  components: {
    Alert,
    KBStatusBadge,
    KBVisibilityBadge,
    CreateKBContent
  }
})
export default class extends GiganautVue {
  private search = '';
  private activeTab = 0;
  private createDialog = false;

  private headers = [
    { text: 'Title', value: 'title', width: '30%' },
    { text: 'Status', value: 'status' },
    { text: 'Visibility', value: 'visibility' },
    { text: 'Has Draft', value: 'hasDraft', align: 'center' },
    { text: 'Last Published', value: 'publishedDate' },
  ];

  get loading(): boolean {
    return SysKBContentListModule.loading;
  }

  get loadingList(): boolean {
    return SysKBContentListModule.loading;
  }

  get allContent(): KBContentListItem[] {
    return SysKBContentListModule.contentList?.items || [];
  }

  get filteredContent(): KBContentListItem[] {
    switch (this.activeTab) {
      case 1: // Published
        return this.allContent.filter(item => item.status === KBStatus.Published);
      case 2: // Drafts - show only articles that have never been published
        return this.allContent.filter(item =>
          item.status === KBStatus.Draft && item.publishedVersion === 0
        );
      default: // All
        return this.allContent;
    }
  }

  created() {
    this.loadData();
  }

  async loadData() {
    await SysKBContentListModule.getContentList();
  }

  navigateToContent(item: KBContentListItem) {
    this.$router.push({
      name: PageNames.SysAdminKBContent,
      params: { contentid: item.id }
    });
  }

  createContent() {
    this.createDialog = true;
  }

  onContentCreated(contentId: string) {
    this.createDialog = false;
    this.loadData();
    this.navigateToContent({ id: contentId } as KBContentListItem);
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}
